// AROON.js
import * as d3 from 'd3';
import theme from '../../theme';

export const drawAROON = (svg, data, xScale, yScale, values) => {
    if (!values?.aroon_up || !values?.aroon_down) return;

    const aroonUpPoints = values.aroon_up.map((value, i) => ({
        x: new Date(data[i]?.start_date),
        y: value
    })).filter(d => !isNaN(d.y) && d.y !== null);

    const aroonDownPoints = values.aroon_down.map((value, i) => ({
        x: new Date(data[i]?.start_date),
        y: value
    })).filter(d => !isNaN(d.y) && d.y !== null);

    const lineGenerator = d3.line()
        .x(d => xScale(d.x))
        .y(d => yScale(d.y))
        .curve(d3.curveMonotoneX);

    // Aroon Up
    svg.append('path')
        .datum(aroonUpPoints)
        .attr('fill', 'none')
        .attr('stroke', theme.indicators.aroon.up)
        .attr('stroke-width', 1.5)
        .attr('d', lineGenerator);

    // Aroon Down
    svg.append('path')
        .datum(aroonDownPoints)
        .attr('fill', 'none')
        .attr('stroke', theme.indicators.aroon.down)
        .attr('stroke-width', 1.5)
        .attr('d', lineGenerator);
};
